module.exports = __webpack_public_path__ + "static/media/systray_302.ce872361.ico";